import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=38cd4c62"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"
import style0 from "./contextMenu.vue?vue&type=style&index=0&id=38cd4c62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports